import React from 'react';

const VesselHUD = ({
    speed,
    heading,
    threatDetected,
    timestamp,
    radarReflectivity
}) => {
    if (speed === undefined || speed === null) return null;

    return (
        <div className="absolute bottom-10 right-4 bg-white/95 dark:bg-slate-800/95 border border-slate-200 dark:border-slate-700 p-4 rounded-lg shadow-lg text-slate-800 dark:text-white z-50 w-64 backdrop-blur-sm dark:bg-slate-900/90 dark:border-slate-600 dark:text-white">
            <h3 className="text-sm font-bold border-b border-slate-200 dark:border-slate-700 pb-2 mb-2 flex justify-between items-center dark:border-slate-700">
                <span>Vessel Telemetry</span>
                {threatDetected === 'Yes' && (
                    <span className="text-xs bg-red-600 px-2 py-0.5 rounded animate-pulse">THREAT</span>
                )}
            </h3>

            <div className="space-y-2 text-sm font-mono">
                <div className="flex justify-between">
                    <span className="text-slate-500 dark:text-slate-400 dark:text-slate-400">Time:</span>
                    <span>{new Date(timestamp).toLocaleTimeString()}</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-slate-500 dark:text-slate-400 dark:text-slate-400">Speed:</span>
                    <span className="text-blue-600 dark:text-blue-400 dark:text-cyan-400">{speed.toFixed(1)} kn</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-slate-500 dark:text-slate-400 dark:text-slate-400">Heading:</span>
                    <span className="text-amber-600 dark:text-yellow-400 dark:text-amber-400">{heading.toFixed(0)}°</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-slate-500 dark:text-slate-400 dark:text-slate-400">RCS:</span>
                    <span>{radarReflectivity ? radarReflectivity.toFixed(1) : 'N/A'} dB</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-slate-500 dark:text-slate-400 dark:text-slate-400">Coordinates:</span>
                    <span></span>
                </div>
            </div>

            {/* Visual Heading Indicator */}
            <div className="mt-3 flex justify-center">
                <div className="relative w-16 h-16 border-2 border-slate-300 dark:border-slate-600 rounded-full flex items-center justify-center bg-slate-50 dark:bg-slate-800 dark:border-slate-700 dark:bg-slate-800">
                    <div
                        className="absolute w-1 h-3 bg-red-500 top-0 left-1/2 -translate-x-1/2" // North marker
                    ></div>
                    <svg
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        className="text-blue-600 dark:text-blue-400 transition-transform duration-75 dark:text-cyan-400"
                        style={{ transform: `rotate(${heading}deg)` }}
                    >
                        <path d="M12 2L12 22M12 2L5 9M12 2L19 9" />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default VesselHUD;